export default function ModalScheduleMeeting(
  $uibModalInstance,
  $rootScope,
  $sce,
  title,
  meetingLink
) {
  'ngInject';

  this.cancel = () => $uibModalInstance.dismiss('cancel');

  this.account = $rootScope.account;
  this.user = $rootScope.user;
  this.title = title;
  var meetingLink = meetingLink;

  var nameParts = this.user.name.split(' ');
  meetingLink += `&email=${this.user.email}&firstName=${nameParts[0]}&lastName=${nameParts[1]}&organization_name=${this.account.name}`;
  this.meetingLink = $sce.trustAsResourceUrl(meetingLink);
}



// WEBPACK FOOTER //
// ./app/pages/settings/modal-schedule-meeting.js